module.exports = __webpack_public_path__ + "img/menu_professional_banner.02d5528e.png";